import { NotOverridableComponentProps } from '../../../../model/Component'
import { AppBox } from './AppBox'

export type AppArticleProps = NotOverridableComponentProps

export function AppArticle(props: AppArticleProps) {
  return <AppBox component={'article'} {...props} />
}
